$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');

  if (p === 'today_orders') {
    $('#order-fliter').select2({
      theme: 'bootstrap4',
      width: '300px',
      minimumResultsForSearch: -1,
    });

    $(document).on('click', '.send-order-email', function () {
      let orderId = $(this).data('order-id');
      $('#emailReceiptModal #order_id').val(orderId);
      $('#emailReceiptModal').modal('show');
    });

    $(document).on('change', '#order-fliter', function (e) {
      var value = $(this).val();

      // Desktop table rows
      $('#order-list-table tbody tr').each(function () {
        var isInvoice = $(this).data('is-invoice-order') == 1;
        if (value === 'all') {
          $(this).show();
        } else if (value === 'invoice') {
          $(this).toggle(isInvoice);
        } else if (value === 'order') {
          $(this).toggle(!isInvoice);
        }
      });

      // Mobile cards
      $('.mobile-view .product-list-card').each(function () {
        var isInvoice =
          $(this).find('.list-group').data('is-invoice-order') == 1;
        if (value === 'all') {
          $(this).show();
        } else if (value === 'invoice') {
          $(this).toggle(isInvoice);
        } else if (value === 'order') {
          $(this).toggle(!isInvoice);
        }
      });
    });
  }
});
